import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid, parseOptions, getParam} from '../question-helper';
import { GlobalQuestionService } from '../../services/global-question.service';

@Component({
    selector: 'app-question-radio',
    templateUrl: './question-radio.component.html',
    styleUrls: ['./question-radio.component.scss'],
    standalone: false
})
export class QuestionRadioComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = false;
  @Input() controlCssClass: string;
  @Output() questionAnswer = new EventEmitter();
  @Output() selectedOption = new EventEmitter();

  uniqueControlName = `radio-name-${newGuid()}`;
  items: any[] = [];
  skipped = false;
  showSkip = false;
  parameter: any;
  questions: Question[];
  parent_id = 0;
  additionalQuestion = false;
  constructor(private questionService: GlobalQuestionService) { }

  ngOnInit(): void {
    try {
      this.parameter = JSON.parse(this.question.parameter);
    } catch (e) { }
    if (getParam(this.parameter, 'show_skip')?.value === '1') {
      this.showSkip = true;
    }

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;
      if (this.question?.options) {
        this.items = parseOptions(this.question?.options
        );
        if (this.items?.length) {
          this.items.sort((a, b) => a.answer_order > b.answer_order ? 1 : a.answer_order < b.answer_order ? -1 : 0);
        }
      }
      this.items.forEach(o => {
        if (o.answer == this.question.answer){
          this.checkRadio(o);
          this.questionAnswer.emit(this.question)
        }
      });
    }
    if (changes?.readOnly?.currentValue !== changes?.readOnly?.previousValue) {
      this.readOnly = changes?.readOnly?.currentValue;
    }
    if (changes?.showLabel?.currentValue !== changes?.showLabel?.previousValue) {
      this.showLabel = changes?.showLabel?.currentValue;
    }
    
  }

  checkRadio(option: any): void {
    this.questions = [];
    
    if (option?.additional_question_json) {
      this.additionalQuestion = true;
      this.question.answer = option.answer;
      this.question.answer_id = option?.cent_aq_answer_id;
      //this.questionAnswer.emit(this.question);
      let questions = JSON.parse(option?.additional_question_json);
      questions.forEach(q => {
        this.questionService.getQuestion(q.question_id).subscribe((ques) => {
          this.questions.push(ques[0])
        });
      });
      let stringQuestions = JSON.stringify(this.questions);
      this.questions = JSON.parse(stringQuestions);
    }
    else {
      this.additionalQuestion = false;
      this.question.answer = option.answer;
      this.questionAnswer.emit(this.question);
    }
    
  }
  onSkipChange(): void {
    if (this.skipped) {
      this.question.answer = 'skipped';
    } else {
      this.question.answer = '';
    }
    this.questionAnswer.emit(this.question);
  }
  onChange(event: any, index: any): void {
    console.log(event, this.questions);
    if (this.questions.every(q => q.answer)) {
      //this.question.answer = 'Multiple answers';
      this.questionService.saveAnswersOnly(this.questions);
      this.questionAnswer.emit(this.question);
    }
    else{
      //this.question.answer = '';
      this.questionAnswer.emit(this.question);
    }
  }
    
}
